import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {Tooltip} from '../../domain/tooltip';
import {ValidationConstraint} from '../../domain/validation-constraint';


@Component({
    selector: 'app-tab',
    template: ''
})
export class TabComponent implements OnDestroy {
    protected subscriptions = [];
    protected config;
    protected tooltips: Tooltip[];
    protected validationConstraints: ValidationConstraint[];
    @Output() tabCompleted = new EventEmitter<string>();

    constructor() {
    }

    protected onSubmit(currentState: string) {
        this.tabCompleted.emit(currentState);
    }


    protected afterConfigLoaded() {

    }

    protected afterCaseLoaded() {

    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
